// extracted by mini-css-extract-plugin
export default {"apply":"SubmitButton_apply__dbdzJ","buttons":"SubmitButton_buttons__xaQeh"};